import {
  DetailType,
  HandballMissedThrowAttribute,
} from '@collector/sportsapi-client-legacy'

import { DetailConfiguration } from '../../../../composables/useSportOptions'
import { GroupName } from '../../consts'

export const groups: Map<
  GroupName,
  DetailConfiguration<HandballMissedThrowAttribute>
> = new Map([
  [
    GroupName.Style,
    {
      type: DetailType.Button,
      name: GroupName.Style,
      important: true,
      attributes: [
        HandballMissedThrowAttribute.Air,
        HandballMissedThrowAttribute.Ground,
      ],
      cols: 2,
      multiple: false,
    },
  ],
  [
    GroupName.Type,
    {
      type: DetailType.Button,
      name: GroupName.Type,
      important: false,
      attributes: [
        HandballMissedThrowAttribute.FastAttack,
        HandballMissedThrowAttribute.AfterTurnover,
        {
          attributeId: HandballMissedThrowAttribute.Pivot,
          isActive: (attributes: readonly HandballMissedThrowAttribute[]) => {
            return !attributes.some((attribute) =>
              [
                HandballMissedThrowAttribute.LeftWing,
                HandballMissedThrowAttribute.RightWing,
                HandballMissedThrowAttribute.NineMeter,
              ].includes(attribute),
            )
          },
        },
        {
          attributeId: HandballMissedThrowAttribute.Breakthrough,
          isActive: (attributes: readonly HandballMissedThrowAttribute[]) => {
            return !attributes.some((attribute) =>
              [
                HandballMissedThrowAttribute.LeftWing,
                HandballMissedThrowAttribute.RightWing,
                HandballMissedThrowAttribute.NineMeter,
              ].includes(attribute),
            )
          },
        },
        HandballMissedThrowAttribute.ThrowWoodwork,
      ],
      cols: 3,
      multiple: true,
    },
  ],
])
